var Base = require('front/components/Base/Base');
var _ = require('underscore');

require('front/components/BroadcastSide/BroadcastSide');
require('front/components/BlockText/BlockText');
require('front/components/BlockImage/BlockImage');
require('front/components/BlockVideo/BlockVideo');
var BlockGallery = require('front/components/BlockGallery/BlockGallery');
var Gallery = require('front/components/Gallery/Gallery');
require('front/components/BlockEmbed/BlockEmbed');
require('front/components/Tag/Tag');
var ArticlesList = require('front/components/ArticlesList/ArticlesList');
require('front/components/Header/Header');
require('front/components/ViewCount/ViewCount');

require('./Broadcast.less');

module.exports = Base.extend({
    el: '.Broadcast',

    initialize: function () {
        this.gallery = new Gallery();

        _.each(this.$('.BlockGallery'), function (el) {
            new BlockGallery({
                el: el,
                galleryView: this.gallery
            });
        }.bind(this));

        this.broadcastsList = new ArticlesList({
            limit: 14,
            dataOptions: {
                project: app.data.project.id,
                article: app.data.broadcastId
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Broadcast/Broadcast.js
// module id = 183
// module chunks = 0